import React from 'react';
import Button from '../../../../../components/control/button/button';
import {
    EButtonSize,
    EButtonType,
} from '../../../../../components/control/button/button.types';
import { useFormikContext } from 'formik';

const ButtonFilterClear: React.FC<{ onClear?: () => void; label?: string }> = ({
    onClear,
    label = 'Clear date filter',
}) => {
    const form = useFormikContext();

    return (
        <Button
            styleType={EButtonType.Outline}
            size={EButtonSize.Small}
            type={'button'}
            onClick={() => {
                form.resetForm();
                onClear && onClear();
            }}
        >
            {label}
        </Button>
    );
};

export default ButtonFilterClear;
